import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static classes = ["hidden"];
  static targets = ["content"];

  contentTargetConnected() {
    this.contentTarget.addEventListener("turbo:before-frame-render", this.open.bind(this))
    this.contentTarget.addEventListener("turbo:submit-end", this.closeOnSuccess.bind(this))
  }

  contentTargetDisconnected() {
    this.contentTarget.removeEventListener("turbo:before-frame-render", this.open.bind(this))
    this.contentTarget.removeEventListener("turbo:submit-end", this.closeOnSuccess.bind(this))
  }

  closeOnSuccess(event) {
    if (event.detail.success) this.close();
  }

  open() {
    this.element.showModal();
    this.element.classList.remove(...this.hiddenClasses);
  }

  close() {
    this.contentTarget.innerHTML = "";
    this.element.classList.add(...this.hiddenClasses);
    this.element.close();
  }
}
